import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "tresses_cart";

export const CartProvider = ({ children }) => {
    const [items, setItems] = useState(() => {
        try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]"); } catch { return []; }
    });
    const [open, setOpen] = useState(false);

    useEffect(() => {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    }, [items]);

    const addItem = (product, qty = 1) => {
        setItems((prev) => {
            const existing = prev.find((x) => x.id === product.id);
            if (existing) {
                return prev.map((x) => x.id === product.id ? { ...x, quantity: x.quantity + qty } : x);
            }
            return [...prev, { id: product.id, name: product.name, price: product.price, image: product.image, quantity: qty }];
        });
        setOpen(true);
    };

    const updateQty = (id, qty) => {
        if (qty < 1) return removeItem(id);
        setItems((prev) => prev.map((x) => x.id === id ? { ...x, quantity: qty } : x));
    };

    const removeItem = (id) => setItems((prev) => prev.filter((x) => x.id !== id));
    const clear = () => setItems([]);

    const total = items.reduce((sum, x) => sum + x.price * x.quantity, 0);
    const count = items.reduce((sum, x) => sum + x.quantity, 0);

    return (
        <CartContext.Provider value={{ items, total, count, open, setOpen, addItem, updateQty, removeItem, clear }}>
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => useContext(CartContext);
